// components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

// Define the PrivateRoute component
// It takes two props:
// - isAuthenticated: a boolean indicating whether the user is logged in
// - children: the component(s) to render if the user *is* authenticated
const PrivateRoute = ({ isAuthenticated, children }) => {
    // If the user is authenticated, render the children (protected content)
    // If not, redirect them to the LoginPage
    return isAuthenticated ? children : <Navigate to="/LoginPage" />;
};

export default PrivateRoute;